
export const obtainCareerDefault = () => {
    const currentStudentRecord = localStorage.getItem('currentStudentRecord')
    return JSON.parse(currentStudentRecord!).name
}

